var e=r=>!!r;var t=(r="lang")=>()=>[window?.localStorage?.getItem(r)].filter(e),xe=t();export{t as initLocalStorageDetector,xe as localStorageDetector};
